module.exports = __webpack_public_path__ + "static/media/icon_house.2a04b896.svg";